<template>
  <div class="grid grid-cols-2 col-gap-14 row-gap-4">
    <div class="col-span-2">
      <h1>Pricing</h1>
    </div>
    <div v-if="user.role === 'admin'" class="col">
      <base-label>Standard commission ({{ commission_display }}%)</base-label>
      <vue-slider
        v-model="outfitter.commission"
        @change="handleCommissionChange"
      ></vue-slider>
    </div>
    <div v-if="user.role === 'admin'" class="col">
      <base-label>24hr commission ({{ commission_24_display }}%)</base-label>
      <vue-slider
        v-model="outfitter.commission_24"
        @change="handleCommission24Change"
      ></vue-slider>
    </div>
    <div class="col">
      <base-label>24 hour discount ({{ discount_24_display }}%)</base-label>
      <vue-slider
        v-model="outfitter.discount_24"
        @change="handleDiscount24Change"
      ></vue-slider>
    </div>
    <div class="col">
      <base-label>Limit purchases to full display groups</base-label>
      <toggle-button
        v-model="display_group_only"
        :labels="{ checked: 'Yes', unchecked: 'No' }"
        :sync="true"
      ></toggle-button>
    </div>
    <div class="col">
      <base-label>Allow checkout at counter</base-label>
      <toggle-button
        v-model="allow_checkout_at_counter"
        :sync="true"
        :labels="{ checked: 'Yes', unchecked: 'No' }"
        @change="handleCheckoutChange"
      ></toggle-button>
    </div>
    <div class="col">
      <div v-show="allow_checkout_at_counter">
        <base-label>Require checkout at counter</base-label>
        <toggle-button
          v-model="require_checkout_at_counter"
          :labels="{ checked: 'Yes', unchecked: 'No' }"
          :sync="true"
        ></toggle-button>
      </div>
    </div>
    <div class="col">
      <base-label>Processing fee</base-label>
      <base-currency
        :value="outfitter.processing_fee"
        @change="outfitter.processing_fee = $event"
      >
      </base-currency>
    </div>
    <div class="col">
      <base-label>Display group price</base-label>
      <base-currency
        :value="outfitter.display_group_price"
        @change="outfitter.display_group_price = $event"
      >
      </base-currency>
    </div>
    <div class="col-span-2">
      <base-button-primary @click="save">Save</base-button-primary>
    </div>
  </div>
</template>

<script>
import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/antd.css";
import { ToggleButton } from "vue-js-toggle-button";

export default {
  name: "Pricing",
  components: {
    VueSlider,
    ToggleButton,
  },
  data() {
    return {
      pricing: {},
      display_group_only: false,
      allow_checkout_at_counter: false,
      require_checkout_at_counter: false,
      commission_display: 0,
      commission_24_display: 0,
      discount_24_display: 0,
    };
  },
  methods: {
    handleCommission24Change() {
      this.commission_24_display = this.outfitter.commission_24;
    },
    handleDiscount24Change() {
      this.discount_24_display = this.outfitter.discount_24;
    },
    handleCommissionChange() {
      this.commission_display = this.outfitter.commission;
    },
    handleCheckoutChange() {
      if (!this.allow_checkout_at_counter) {
        this.require_checkout_at_counter = false;
      }
    },
    handleSwitches(outfitter) {
      this.allow_checkout_at_counter = outfitter.allow_checkout_at_counter
        ? true
        : false;
      this.display_group_only = outfitter.display_group_only ? true : false;
      this.require_checkout_at_counter = outfitter.require_checkout_at_counter
        ? true
        : false;
      this.commission_display = outfitter.commission;
      this.commission_24_display = outfitter.commission_24;
      this.discount_24_display = outfitter.discount_24;
    },
    save() {
      this.outfitter.allow_checkout_at_counter = this.allow_checkout_at_counter
        ? 1
        : 0;
      this.outfitter.require_checkout_at_counter = this
        .require_checkout_at_counter
        ? 1
        : 0;
      this.outfitter.display_group_only = this.display_group_only ? 1 : 0;
      this.$store
        .dispatch("outfitter/save_outfitter", this.outfitter)
        .then((resp) => {
          if (!resp.success) return;

          this.$notify({
            title: "Settings",
            message: "Data Saved",
            type: "success",
          });
        });
    },
  },
  computed: {
    user: function () {
      return this.$store.getters["auth/getUser"];
    },
    outfitter: function () {
      const outfitter = this.$store.getters["outfitter/getOutfitter"];
      this.handleSwitches(outfitter);
      return outfitter;
    },
  },
  mounted() {},
};
</script>
